import { Component } from 'react';
import PropTypes from 'prop-types';

export default class ClickOutside extends Component {
  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.handleClickOutside();
    }
  }

  render() {
    return (
      <div className="outside" ref={this.setWrapperRef}>
        {this.props.children}
      </div>
    );
  }
}

ClickOutside.propTypes = {
  children: PropTypes.element.isRequired,
};
